import { z } from "zod";

import { NEWSLETTER_SEARCH_MAX_LENGTH } from "./components/NewsletterSearchInput";

export const newsletterSearchQuerySchema = z
  .union([z.string(), z.number()])
  .transform(
    value =>
      String(value).trim().slice(0, NEWSLETTER_SEARCH_MAX_LENGTH) || undefined,
  )
  .optional()
  .catch(undefined);
